module.exports = __webpack_public_path__ + "img/hover_icon_manejo_de_tarjetas.196c9ea6.svg";